import { extendTheme } from "native-base";

export const theme = extendTheme({
  colors: {
    primary: {
      50: "#243783",
      100: "#F1F5F4",
      200: "#A0A0A0",
    },
    success: {
      50: "#008B9C",
      100: "#00FF00",
      200: "#00B050",
    },
    warning: {
      50: "#FF0000",
    },
  },
});
